export const envInfo = {
  httpProtocol: import.meta.env.VITE_API_PROTOCOL || "https",
  wsProtocol: import.meta.env.VITE_WS_PROTOCOL || "wss",
  n8nEntryPoint: import.meta.env.VITE_N8N_URL,
  entryPoint: import.meta.env.VITE_API_HOST || "backend-beta.flowls.app",
};

export const isDemoEnvironment = window.location.hostname === "demo.flowls.app";

export const URI = `${envInfo.httpProtocol}://${envInfo.entryPoint}/graphql`;
export const EXTERNAL_URI = `${envInfo.httpProtocol}://${envInfo.entryPoint}/external/graphql`;

export const WS_URI = `${envInfo.wsProtocol}://${envInfo.entryPoint}/socket`;
